// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__pKYSs","list":"PatternAutocomplete_list__1r1GH"};